var _rect, _g, _rect2, _rect3, _g2, _rect4, _g3, _path, _path2, _path3, _path4, _g4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSonicCustomizationFeature04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 200,
    viewBox: "0 0 249 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80.6406,
    width: 145.357,
    height: 113.643,
    rx: 11.76,
    fill: "url(#paint0_linear_2125_5397)",
    fillOpacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2125_5397)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.6875,
    y: 7.04688,
    width: 131.262,
    height: 99.5476,
    rx: 8,
    fill: "#3866C2",
    fillOpacity: 0.2
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 120.281,
    y: 11.4531,
    width: 66.0714,
    height: 4.40476,
    rx: 2.20238,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 49.332,
    width: 66.0714,
    height: 135.667,
    rx: 11.76,
    fill: "url(#paint1_linear_2125_5397)",
    fillOpacity: 0.4
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_2125_5397)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.28906,
    y: 54.6172,
    width: 55.5,
    height: 125.095,
    rx: 8,
    fill: "#3866C2",
    fillOpacity: 0.2
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 19.8594,
    y: 59.0215,
    width: 34.3571,
    height: 4.40476,
    rx: 2.20238,
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2125_5397)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 104,
    width: 162,
    height: 10,
    rx: 4.24306,
    fill: "#111111"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.5938 186.433C87.2008 193.927 102.848 198.193 119.496 198.193C155.19 198.193 186.289 178.581 202.532 149.58",
    stroke: "url(#paint2_linear_2125_5397)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.457 21.5524L77.5856 23.8144L75.3235 29.9429",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1871 194.261L73.0245 186.19L81.0954 184.027",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0338 24.719C65.1831 29.5244 57.3896 35.7277 46.2868 49.2898",
    stroke: "url(#paint3_linear_2125_5397)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2125_5397)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 78,
    width: 162,
    height: 58,
    rx: 5.58281,
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5271 93.4746C67.0123 93.4746 67.4555 93.7501 67.6702 94.1852L71.3131 101.565L79.4598 102.756C79.9398 102.826 80.3384 103.163 80.4881 103.624C80.6377 104.086 80.5124 104.592 80.1649 104.931L74.2711 110.671L75.662 118.781C75.7441 119.26 75.5474 119.743 75.1548 120.028C74.7622 120.313 74.2417 120.351 73.8122 120.125L66.5271 116.294L59.242 120.125C58.8125 120.351 58.292 120.313 57.8994 120.028C57.5067 119.743 57.3101 119.26 57.3921 118.781L58.7831 110.671L52.8893 104.931C52.5417 104.592 52.4165 104.086 52.5661 103.624C52.7157 103.163 53.1143 102.826 53.5944 102.756L61.741 101.565L65.3839 94.1852C65.5987 93.7501 66.0419 93.4746 66.5271 93.4746ZM66.5271 97.6296L63.731 103.294C63.5455 103.67 63.187 103.931 62.7722 103.991L56.5176 104.906L61.0424 109.313C61.3431 109.606 61.4804 110.028 61.4094 110.441L60.3418 116.666L65.9337 113.725C66.3052 113.53 66.749 113.53 67.1205 113.725L72.7123 116.666L71.6448 110.441C71.5738 110.028 71.7111 109.606 72.0118 109.313L76.5365 104.906L70.2819 103.991C69.8672 103.931 69.5087 103.67 69.3232 103.294L66.5271 97.6296Z",
    fill: "#111111"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M126.448 94.75L123.898 97.2997M114.196 107.001L119.436 101.762M119.436 101.762L123.26 105.586L127.722 101.124L123.898 97.2997M119.436 101.762L123.898 97.2997M114.196 107.001C114.855 107.651 115.378 108.424 115.736 109.276C116.094 110.129 116.28 111.044 116.283 111.969C116.286 112.893 116.107 113.81 115.754 114.665C115.402 115.519 114.884 116.296 114.23 116.95C113.576 117.604 112.799 118.122 111.944 118.475C111.089 118.827 110.173 119.007 109.248 119.004C108.324 119.001 107.409 118.815 106.556 118.456C105.703 118.098 104.93 117.575 104.281 116.917C103.004 115.594 102.297 113.823 102.313 111.985C102.329 110.146 103.066 108.388 104.366 107.088C105.666 105.788 107.425 105.05 109.263 105.034C111.102 105.018 112.873 105.725 114.195 107.002L114.196 107.001Z",
    stroke: "#111111",
    strokeWidth: 2.54966,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M164.453 101.391V107.573C164.453 107.737 164.533 107.892 164.667 107.988L167.449 109.973",
    stroke: "#111111",
    strokeWidth: 2.55162,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M154.054 107.285C154.055 104.839 154.882 102.465 156.402 100.549C157.923 98.6337 160.046 97.2886 162.428 96.7328C164.81 96.177 167.309 96.4432 169.52 97.4881C171.732 98.5331 173.524 100.295 174.607 102.488C175.69 104.681 175.999 107.176 175.484 109.567C174.969 111.958 173.66 114.104 171.771 115.657C169.881 117.21 167.522 118.078 165.077 118.12C162.631 118.162 160.244 117.375 158.302 115.888",
    stroke: "#111111",
    strokeWidth: 2.55162,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M158.163 105.543L153.997 107.899C153.752 108.037 153.44 107.951 153.301 107.706L150.945 103.539",
    stroke: "#111111",
    strokeWidth: 2.55162,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2125_5397",
    x: 68.7446,
    y: -11.896,
    width: 169.147,
    height: 137.433,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9.47144
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2125_5397"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2125_5397",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_2125_5397",
    x: -9.65382,
    y: 35.6743,
    width: 93.3858,
    height: 162.981,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9.47144
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2125_5397"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2125_5397",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2125_5397",
    x: 65.3924,
    y: 95.5139,
    width: 183.215,
    height: 31.2153,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.12153
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.30382
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2125_5397"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2125_5397",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2125_5397",
    x: 20.043,
    y: 66.8344,
    width: 189.914,
    height: 85.9141,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.79141
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.97852
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2125_5397"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2125_5397",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2125_5397",
    x1: 153.319,
    y1: 0,
    x2: 153.319,
    y2: 113.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3866C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3866C2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2125_5397",
    x1: 37.0357,
    y1: 49.332,
    x2: 37.0357,
    y2: 184.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3866C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3866C2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2125_5397",
    x1: 105.308,
    y1: 193.331,
    x2: 193.869,
    y2: 174.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2125_5397",
    x1: 60.6946,
    y1: 25.3351,
    x2: 61.6321,
    y2: 48.6734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonicCustomizationFeature04);
export default __webpack_public_path__ + "static/media/sonic-customization-feature-04.e257935b393298e30e1c93d9de16e9fc.svg";
export { ForwardRef as ReactComponent };